import React from 'react';
import clsx from 'clsx';

type BadgeVariant = 'cascade' | 'manual' | 'admin';

const VARIANT_CLASSES: Record<BadgeVariant, string> = {
    // "cascade" + "admin" both convey "positive / included" — route through
    // brand so tenant rebrands repaint them.  "manual" stays blue as the
    // intentional contrast — it's the "this was explicitly selected by a
    // human" signal and needs to read as a distinct state from the brand.
    cascade: 'bg-mld-primary/10 text-mld-primary ring-1 ring-mld-primary/30',
    manual: 'bg-mld-info/10 text-mld-info ring-1 ring-blue-300',
    admin: 'bg-mld-primary/10 text-mld-primary ring-1 ring-mld-primary/30',
};

interface CatalogBadgeProps {
    label: string;
    variant?: BadgeVariant;
}

const CatalogBadge: React.FC<CatalogBadgeProps> = ({label, variant = 'admin'}) => (
    <span
        className={clsx(
            'rounded-full px-2 py-0.5 text-[9px] font-semibold',
            VARIANT_CLASSES[variant],
        )}>
        {label}
    </span>
);

export {CatalogBadge};
export type {BadgeVariant};
